import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { CreditLimitMinValidator } from './credit-limit-min.validator';

@Injectable()
export class DashboardValidators {
    public static creditLimitMinValidator: (min: number) => ValidatorFn;

    constructor(private creditLimitMinValidator: CreditLimitMinValidator) {
        DashboardValidators.creditLimitMinValidator = this.creditLimitMinValidator.validator.bind(
            this.creditLimitMinValidator
        );
    }
}
